<template>
    <v-dialog v-model="dialog" max-width="500" persistent>
      <v-card>
          <v-card-title class="primary white--text title">
              {{'Test Message'|translate}}
          </v-card-title>
          <v-card-text>
              <v-form v-model="valid">
              <v-text-field
                      :label="'Phone number'|translate"
                      v-model="sms.phone"
              >
              </v-text-field>
              <v-text-field
                      :label="'Message'|translate"
                      v-model="sms.message"
                      counter="160"
              >
              </v-text-field>
              </v-form>


          </v-card-text>

          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn outline class="mr-2" @click="dialog=false">{{'Cancel'|translate}}</v-btn>
              <v-btn class="primary mr-2 elevation-4" @click="sendSMS()" :disabled="!valid">{{'Send'|translate}}</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  import {callAPI} from '../../helper'

  export default {
    props: {
      value: {type:Boolean, default: true},
    },
    watch: {
      value () {
        if (this.dialog !=this.value){
          this.dialog=this.value
        }
      },
      dialog () {
        this.$emit('input', this.dialog)
      }
    },
    data () {
      return {
          phoneRules: [value => !!value || 'This value is required.'],
          messageRules: [value => !!value || 'This value is required.',v => v.length <= 160 || 'This value cannot exceed 160 characters.'],
          sms:{
              phone:"",
              message:"",
          },
          valid:true,
        dialog: false,
      }
    },
    methods: {
        sendSMS(){
            callAPI('sms/',
                this.sms
            )
            this.dialog=false;

        }
    },
    name: 'SmsDialog'
  }
</script>

<style scoped>

</style>
